import React, { Component } from "react";
import clsx from "clsx";

import "./tools-avatar.css";

const TINT_COUNT = 5;

function initialsOf({ name }) {
	const words = String(name || "")
		.trim()
		.split(/\s+/)
		.filter(Boolean);
	const firstLetters = words.slice(0, 2).map(word => word[0].toUpperCase());
	const initials = firstLetters.join("");
	return initials || "?";
}

function tintOf({ name }) {
	const text = String(name || "");
	let hash = 0;
	for (let index = 0; index < text.length; index += 1) hash = (hash * 31 + text.charCodeAt(index)) % 1000003;
	const tint = (hash % TINT_COUNT) + 1;
	return tint;
}

class ToolsAvatar extends Component {
	render() {
		const { name, size = "md", className } = this.props;
		const initials = initialsOf({ name });
		const tint = tintOf({ name });

		return (
			<span className={clsx("tools-avatar", `tools-avatar--${size}`, `tools-avatar--tint-${tint}`, className)} title={name} aria-hidden="true">
				{initials}
			</span>
		);
	}
}

export default ToolsAvatar;
